import React from 'react';
import clsx from 'clsx';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import ProductDetailCanceledStatus from '../../ProductDetailCanceledStatus';
import ProductDetailLink from '../../ProductDetailLink';
import type { ShoppingListSubject } from '../../../api/shoppingLists';
import { isProductCanceled } from '../../../helpers/isProductCanceled';
import useProductUrl from '../../../hooks/useProductUrl';
import useTranslateWithFallback from '../../../hooks/useTranslateWithFallback';

export type ShoppingListItemNameClassKey = 'root' | 'crossedText';

const useStyles = makeStyles((theme: Theme) =>
  createStyles<ShoppingListItemNameClassKey, {}>({
    root: {
      ...theme.typography.subtitle1,
      color: theme.palette.text.primary,
    },
    crossedText: {
      textDecoration: 'line-through',
    },
  }),
);

const ShoppingListItemName: React.FC<{
  item: Pick<ShoppingListSubject, 'product'>;
}> = ({ item }) => {
  const classes = useStyles();
  const t = useTranslateWithFallback();
  const to = useProductUrl(item.product);

  const productIsCanceled = isProductCanceled(item.product.taxonomies);

  return (
    <div className={classes.root}>
      <ProductDetailLink
        className={clsx({
          [classes.crossedText]: productIsCanceled,
        })}
        to={to}
        variant='inherit'
        noWrap
      >
        {t(item.product.name, { acceptString: true })}
      </ProductDetailLink>
      {productIsCanceled && <ProductDetailCanceledStatus />}
    </div>
  );
};

ShoppingListItemName.displayName = 'ShoppingListItemName';

export default ShoppingListItemName;
